import { useEffect, useState } from "react";
import { DotLegalSelectOption } from "../components/dotLegalMultiSelect/DotLegalMultiSelect.types";
import { useTranslation } from "../../localization/useTranslation";

import { useDotLegalQuery, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export default function useCountryHook() {
    const { translateCountry } = useTranslation();
    const [countryList, setCountryList] = useState<Array<DotLegalSelectOption>>([]);

    let { data, isLoading } = useDotLegalQueryWithKey<Array<CountryViewModel>>("countries", "/Countries");

    useEffect(() => {
        if (data) {
            let countries = data.map((country) => {
                return {
                    name: translateCountry(country.countryCode),
                    id: country.countryCode,
                };
            });
            setCountryList(countries);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    return {
        selectableCountries: countryList,
        countriesIsLoading: isLoading,
        countries: data ?? [],
        thirdCountries: data?.filter((x) => x.isThirdCountry).map((x) => x.countryCode) ?? [],
    };
}

export interface CountryViewModel {
    countryCode: string;
    isThirdCountry: boolean;
}
